import React from 'react';
import { useTranslation } from 'react-i18next';
import { Search, Filter } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

const CalendriersFiltersCard = ({
  searchTerm, setSearchTerm,
  yearFilter, setYearFilter,
  countryFilter, setCountryFilter,
  statusFilter, setStatusFilter,
}) => {
  const { t } = useTranslation();

  return (
    <Card>
    <CardHeader>
      <CardTitle className="flex items-center gap-2">
        <Filter className="h-5 w-5" />
        {t("holidayCommon.filters.title")}
      </CardTitle>
    </CardHeader>
    <CardContent>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <div className="space-y-2">
          <Label>{t("holidayCommon.filters.search")}</Label>
          <div className="relative">
            <Search className="absolute left-2 top-2.5 h-4 w-4 text-muted-foreground" />
            <Input
              placeholder={t("holidayCalendarComponents.filters.searchPlaceholder")}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="pl-8"
            />
          </div>
        </div>

        <div className="space-y-2">
          <Label>{t("holidayCommon.fields.year")}</Label>
          <Select value={yearFilter} onValueChange={setYearFilter}>
            <SelectTrigger>
              <SelectValue placeholder={t("holidayCommon.filters.allYears")} />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">{t("holidayCommon.filters.allYears")}</SelectItem>
              <SelectItem value="2024">2024</SelectItem>
              <SelectItem value="2025">2025</SelectItem>
              <SelectItem value="2026">2026</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <Label>{t("holidayCommon.fields.country")}</Label>
          <Select value={countryFilter} onValueChange={setCountryFilter}>
            <SelectTrigger>
              <SelectValue placeholder={t("holidayCommon.filters.allCountries")} />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">{t("holidayCommon.filters.allCountries")}</SelectItem>
              <SelectItem value="Tunisie">Tunisie</SelectItem>
              <SelectItem value="France">France</SelectItem>
              <SelectItem value="Maroc">Maroc</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <Label>{t("holidayCalendarComponents.detail.status")}</Label>
          <Select value={statusFilter} onValueChange={setStatusFilter}>
            <SelectTrigger>
              <SelectValue placeholder={t("holidayCalendarComponents.filters.allStatuses")} />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">{t("holidayCalendarComponents.filters.allStatuses")}</SelectItem>
              <SelectItem value="DRAFT">{t("holidayCalendarComponents.status.DRAFT")}</SelectItem>
              <SelectItem value="APPROVED">{t("holidayCalendarComponents.status.APPROVED")}</SelectItem>
              <SelectItem value="ARCHIVED">{t("holidayCalendarComponents.status.ARCHIVED")}</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>
    </CardContent>
    </Card>
  );
};

export default CalendriersFiltersCard;
